(() => {
  if (!window.GearfullWishlistBridgeLoaded) {
    window.GearfullWishlistBridgeLoaded = true;

    const removeBadInjectedHeaderLink = () => {
      const fake = document.getElementById('gf-header-wishlist-link');
      if (fake) fake.remove();
    };

    removeBadInjectedHeaderLink();
    window.setTimeout(removeBadInjectedHeaderLink, 250);
    window.setTimeout(removeBadInjectedHeaderLink, 1000);
    window.setTimeout(removeBadInjectedHeaderLink, 2500);
  }

  if (window.GearfullBrandSpotlightDesktopClickFixLoaded) return;
  window.GearfullBrandSpotlightDesktopClickFixLoaded = true;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  let press = null;
  let suppressClickUntil = 0;

  const isDesktop = () => desktopQuery.matches;

  const closestAction = (node) =>
    node && node.closest?.(
      '.gf-wishlist-app-host, button, input, select, textarea, summary, [role="button"], [data-no-card-click]'
    );

  const isActiveSlide = (slide) =>
    slide?.classList.contains('is-active') ||
    slide?.getAttribute('aria-current') === 'true';

  const getSlider = (node) => node?.closest?.('[data-gfbp-slider]') || null;

  const getSlideIndex = (slide, slider) => {
    const attrIndex = Number(slide?.dataset?.index);
    if (Number.isInteger(attrIndex) && attrIndex >= 0) return attrIndex;
    return [...slider.querySelectorAll('[data-gfbp-slide]')].indexOf(slide);
  };

  const getSlideFromPoint = (slider, x, y) => {
    if (!slider) return null;

    const directHit = document.elementFromPoint(x, y);
    const directSlide = directHit?.closest?.('[data-gfbp-slide]');
    if (directSlide && slider.contains(directSlide)) return directSlide;

    const slides = [...slider.querySelectorAll('[data-gfbp-slide]')].filter((slide) => {
      if (slide.classList.contains('is-hidden')) return false;
      if (window.getComputedStyle(slide).pointerEvents === 'none') return false;
      const rect = slide.getBoundingClientRect();
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    });

    if (!slides.length) return null;

    slides.sort((a, b) => {
      const aActive = isActiveSlide(a) ? 1 : 0;
      const bActive = isActiveSlide(b) ? 1 : 0;
      if (aActive !== bActive) return aActive - bActive;
      const az = Number(window.getComputedStyle(a).zIndex) || 0;
      const bz = Number(window.getComputedStyle(b).zIndex) || 0;
      return bz - az;
    });

    return slides[0];
  };

  const focusSlide = (slide) => {
    const slider = slide?.closest?.('[data-gfbp-slider]');
    if (!slider) return false;

    const index = getSlideIndex(slide, slider);
    if (index < 0) return false;

    const dot =
      slider.querySelector(`[data-gfbp-dot][data-index="${index}"]`) ||
      slider.querySelector(`[data-gfbp-dot="${index}"]`);

    if (!dot) return false;

    dot.click();
    return true;
  };

  const openActiveProduct = (slide) => {
    const link = slide.querySelector('.gf-product-card__link[href], a[href]');
    const href = link?.getAttribute('href');
    if (!href || href === '#') return false;

    window.location.href = link.href;
    return true;
  };

  const handleClickLikeCardPress = (slide, eventTarget) => {
    if (!slide || closestAction(eventTarget)) return false;

    if (isActiveSlide(slide)) {
      return openActiveProduct(slide);
    }

    if (focusSlide(slide)) {
      suppressClickUntil = Date.now() + 500;
      return true;
    }

    return false;
  };

  document.addEventListener('pointerdown', (event) => {
    if (!isDesktop() || event.button !== 0 || event.pointerType === 'touch') return;

    const slider = getSlider(event.target);
    if (!slider) return;

    press = {
      slider,
      x: event.clientX,
      y: event.clientY,
      startedOnAction: Boolean(closestAction(event.target))
    };
  }, true);

  document.addEventListener('pointerup', (event) => {
    if (!press || !isDesktop() || event.pointerType === 'touch') {
      press = null;
      return;
    }

    const distance = Math.hypot(event.clientX - press.x, event.clientY - press.y);
    const clickLike = distance < 10;
    const slide = clickLike ? getSlideFromPoint(press.slider, event.clientX, event.clientY) : null;
    const elementAtPointer = document.elementFromPoint(event.clientX, event.clientY);

    if (clickLike && slide && press.slider.contains(slide) && !press.startedOnAction) {
      handleClickLikeCardPress(slide, elementAtPointer || event.target);
    }

    press = null;
  }, true);

  document.addEventListener('click', (event) => {
    if (!isDesktop()) return;

    if (Date.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const slider = getSlider(event.target);
    if (!slider) return;

    const slide =
      event.target.closest?.('[data-gfbp-slide]') ||
      getSlideFromPoint(slider, event.clientX, event.clientY);

    if (!slide || !slider.contains(slide)) return;

    if (!isActiveSlide(slide) && handleClickLikeCardPress(slide, event.target)) {
      suppressClickUntil = Date.now() + 500;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();